import api from "./api";
import { sessionId } from "./seo";

const consent = () => { try { return JSON.parse(localStorage.getItem("cs_cookie_consent") || "{}").value === "accepted"; } catch { return false; } };
const cartCount = () => { try { return (JSON.parse(localStorage.getItem("cs_cart") || "[]") || []).length; } catch { return 0; } };

export const livePing = (kind = "ping", label = "") => {
  const path = window.location.pathname;
  if (path.startsWith("/admin")) return;
  const cart = kind === "add" ? Math.max(1, cartCount()) : cartCount();
  api.post("/live/ping", { sid: sessionId(), path, kind, label: String(label || "").slice(0, 80), cart, consent: consent() }).catch(() => {});
};

export function startLiveHeartbeat() {
  const id = setInterval(() => { if (document.visibilityState === "visible") livePing(); }, 25000);
  return () => clearInterval(id);
}
